import { render, staticRenderFns } from "./wasteGoodsDetails.vue?vue&type=template&id=6b7e3fb8&scoped=true&"
import script from "./wasteGoodsDetails.vue?vue&type=script&lang=js&"
export * from "./wasteGoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./wasteGoodsDetails.vue?vue&type=style&index=0&id=6b7e3fb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7e3fb8",
  null
  
)

component.options.__file = "wasteGoodsDetails.vue"
export default component.exports